module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zm-2 19.172l-5.292-7.292a1 1 0 0 0-1.414 0L14 21.172l-3.292-5.294a1 1 0 0 0-1.414 0L4 23.172V4h24v15.172z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/graph-2.js
// module id = 1164
// module chunks = 14